import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { OptionState } from '../../models';
import { Observable } from 'rxjs';
import { FilterPanelService } from '../../services';
import { baseSelectedFilterOptionChipTailwindStyles } from '../../styles';

@Component({
  selector: 'app-selected-fitler-option-chip',
  templateUrl: './selected-fitler-option-chip.component.html',
  styleUrls: ['./selected-fitler-option-chip.component.scss'],
  standalone: false,
})
export class SelectedFitlerOptionChipComponent implements OnInit {
  @HostBinding('class')
  private classes = `${baseSelectedFilterOptionChipTailwindStyles} bg-white`;

  @Input()
  optionId: string;

  @Input()
  fieldId: string;

  optionState$: Observable<OptionState>;
  optionCount$: Observable<number>;

  constructor(private filterManager: FilterPanelService) {}

  ngOnInit(): void {
    this.optionState$ = this.filterManager.getOptionState(this.fieldId, this.optionId);
    this.optionCount$ = this.filterManager.getOptionCount(this.fieldId, this.optionId);
  }

  resetFilterOption(): void {
    this.filterManager.unSelectOptions({ [this.fieldId]: [this.optionId] });
  }
}
